module.exports = __webpack_public_path__ + "img/peter-cyberclass-2.091eb017.png";